import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var Gap = function Gap(props) {
  var width = props.width;
  return /*#__PURE__*/_jsx("div", {
    style: {
      width: "".concat(width, "px"),
      minWidth: "".concat(width, "px")
    },
    "data-testid": "Gap"
  });
};